<template>
    <div class="search-app__card">
        <a :href="getProductURL">
            <div class="search-app__image">
                <img
                    :srcset="createSrcSetString"
                    sizes="(min-width: 1024px) 350px, (min-width: 900px) 250px, (min-width: 750px) 200px, 150px"
                    :src="adjustURL"
                    :alt="product.product_title"
                />
            </div>
            <div class="search-app__info">
                <h3 class="search-app__product-title">{{ product.product_title }}</h3>
                <p class="search-app__product-price">{{ product.price }}</p>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: "SearchProductItem",
    props: ["product"],
    computed: {
        getProductURL(){
          const handle = this.product?.handle || null

          if (!handle) {
            return null
          }

          const url = mint.routes.root === '/'
            ? `//${location.host}/products/${handle}`
            : `//${location.host}${mint.routes.root}/products/${handle}`

          return url
        },
        adjustURL() {
            if(this.product._imageurl) {
                const imageURL = this.product._imageurl;
                return imageURL.replace('.jpg', '_350x.jpg');
            }
        },
        createSrcSetString() {
            if (!this.product._imageurl) return;
            const srcSetValues = [150, 200, 250, 350];
            const imageURL = this.product._imageurl;
            let srcSetString = '';
            srcSetValues.forEach(value => {
                function replaceValue() {
                    return `_${value}x.jpg`
                }
                srcSetString += `${imageURL.replace('.jpg', replaceValue)} ${value}w, `
            });
            return srcSetString.slice(0, -2)
        }
    }
};
</script>
